import { render, staticRenderFns } from "./merchantlist.vue?vue&type=template&id=056e4562&scoped=true"
import script from "./merchantlist.vue?vue&type=script&lang=js"
export * from "./merchantlist.vue?vue&type=script&lang=js"
import style0 from "./merchantlist.vue?vue&type=style&index=0&id=056e4562&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e4562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056e4562')) {
      api.createRecord('056e4562', component.options)
    } else {
      api.reload('056e4562', component.options)
    }
    module.hot.accept("./merchantlist.vue?vue&type=template&id=056e4562&scoped=true", function () {
      api.rerender('056e4562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/official/merchantlist/merchantlist.vue"
export default component.exports